/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import {
  BackgroundIcon,
  COLOR_MAP,
  TEXT_LENGTH,
  DeleteModal,
  getTranslatedText,
  B1,
  withErrorBoundary,
  AccessControl
} from '@nile/components';
import { Popover, TextField } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

const Folder = styled.div`
  cursor: ${(props) => (props.isSearchLoading ? 'not-allowed' : '')};
  position: relative;
  border-radius: 5px;
  min-width: 280px;
  display: inline-block;

  .clicker {
    padding: 12px;
    font-size: 12px;
    cursor: pointer;
    border-radius: 5px;
  }

  &.active,
  &.active:hover {
    color: ${COLOR_MAP.white};
    background: #0b0114;

    .menu-icon {
      color: ${COLOR_MAP.white};
      display: block;
    }
  }

  .name {
    width: 100%;
    max-width: 300px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .folder-icon {
    width: 24px;
    height: 24px;
  }

  .menu-icon {
    display: none;
    position: absolute;
    right: 12px;
    z-index: 100;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  &:hover {
    background: #f7f7fd;
    // font-weight: 700;

    .menu-icon {
      display: block;
    }
  }
`;

const Wrapper = styled.div`
  padding: 8px;
  .danger {
    color: #e02020;
  }
  .Polaris-Button--plain {
    padding: inherit !important;
  }

  hr {
    opacity: 0.1;
    width: 90%;
    margin: 0 auto;
  }
`;

const Option = styled.div`
  display: flex;
  padding: 10px 16px;
  color: ${COLOR_MAP.black};
  font-weight: 400;
  cursor: pointer;
  gap: 12px;

  &:hover {
    background: #f7f7fd;
  }
`;

const FolderTemp = ({
  name,
  item,
  isActive,
  setRenameMode,
  renameMode,
  isSearchLoading,
  options,
  actions,
  intl,
  isExpanded,
  onClick,
  onDoubleClick
}) => {
  const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const [renameValue, setRenameValue] = useState('');
  const [oldName, setOldName] = useState(name);

  useEffect(() => {
    setRenameValue(name);
  }, [name]);

  function openOptionsMenu() {
    setOptionsMenuOpen(!optionsMenuOpen);
    if (!isActive) onClick();
  }

  const activator = (
    <div className="menu-icon fx center" onClick={openOptionsMenu}>
      <SVGIcon name="Menu" color={isActive && COLOR_MAP.white} />
    </div>
  );

  function saveRename() {
    if (renameValue !== oldName) {
      actions.rename(oldName, renameValue, item.parent, item.isDir);
    }
    setRenameMode(false);
  }

  function cancelSave() {
    if (renameValue !== oldName) {
      setRenameMode(false);
      setRenameValue(oldName);
    }
  }

  function onClickHandler() {
    if (!renameMode && !isActive) {
      onClick();
    }
  }

  return (
    <div className="sops-pos-relative">
      <div className="ta-l">
        <Folder
          isSearchLoading={isSearchLoading}
          className={`${isActive ? 'active' : ''}`}
        >
          <div
            className="fx full-height actr clicker"
            onClick={onClickHandler}
            onDoubleClick={onDoubleClick}
          >
            <BackgroundIcon
              className="folder-icon"
              url={`url(${envConfig.imageRoot}svg/${
                isExpanded ? 'folder-yellow' : 'folder-yellow-closed'
              }.svg)`}
            />
            {isActive && renameMode ? (
              <div
                role="textbox"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    saveRename();
                  }
                  if (event.key === 'Escape') {
                    cancelSave();
                  }
                }}
              >
                <TextField
                  id="key"
                  value={renameValue}
                  name="Key"
                  onChange={(val) => {
                    setRenameValue(val);
                  }}
                  placeholder="Enter the Key name"
                  type="text"
                  maxLength={TEXT_LENGTH.size_4}
                  autoFocus
                  onBlur={saveRename}
                />
              </div>
            ) : (
              <span className="ml-10 name pr-25">{name}</span>
            )}
          </div>
          {!renameMode && item?.parent?.length > 0 && (
            <AccessControl
              roleToCheck={{
                operator: 'OR',
                roles: ['fileManager.edit', 'fileManager.delete']
              }}
              render={
                <Popover
                  fullHeight
                  fullWidth={false}
                  active={optionsMenuOpen}
                  activator={activator}
                  preferredAlignment="left"
                  onClose={() => setOptionsMenuOpen(false)}
                  preferInputActivator={false}
                >
                  <Wrapper>
                    {options.map((option) => {
                      const { name: optionname, icon, id: actionType } = option;
                      switch (actionType) {
                        case 'hr':
                          return <hr key={optionname} />;
                        case 'delete':
                          return (
                            <DeleteModal
                              id="deleteRole"
                              key={optionname}
                              modalActivator={
                                <Option>
                                  <div className="flex">
                                    <SVGIcon
                                      name="Delete"
                                      color={COLOR_MAP.red}
                                    />
                                    <div className="ml-10">
                                      <div className="danger">
                                        {getTranslatedText(intl, optionname)}
                                      </div>
                                    </div>
                                  </div>
                                </Option>
                              }
                              description={
                                <>
                                  {getTranslatedText(
                                    intl,
                                    `asset.details.fileExplorer.description.deleteFolder`
                                  )}
                                  <div className="fx mt-10">
                                    <BackgroundIcon
                                      className="icon mr12"
                                      url={`url(${envConfig.imageRoot}svg/folder-yellow.svg)`}
                                    />
                                    <B1>{name}</B1>
                                  </div>
                                </>
                              }
                              handleDeleteConfirmation={() => {
                                actions[actionType].bind(this, item)();
                                if (optionsMenuOpen) setOptionsMenuOpen(false);
                              }}
                              title={getTranslatedText(
                                intl,
                                `asset.details.fileExplorer.title.deleteFolder`
                              )}
                            />
                          );
                        case 'rename':
                          return (
                            <Option
                              key={optionname}
                              onClick={() => {
                                if (optionsMenuOpen) setOptionsMenuOpen(false);
                                setRenameMode(true);
                              }}
                            >
                              <SVGIcon name={icon} />
                              <FormattedMessage id={optionname} />
                            </Option>
                          );
                        default:
                          return (
                            <Option
                              key={optionname}
                              onClick={() => {
                                if (optionsMenuOpen) setOptionsMenuOpen(false);
                                actions[actionType].bind(this, item)();
                              }}
                            >
                              <SVGIcon name={icon} />
                              <FormattedMessage id={optionname} />
                            </Option>
                          );
                      }
                    })}
                  </Wrapper>
                </Popover>
              }
            />
          )}
        </Folder>
      </div>
    </div>
  );
};

const FolderTemplate = withErrorBoundary(injectIntl(FolderTemp));

export { FolderTemplate };
